import React, { PropsWithChildren } from 'react'
import clsx from 'clsx'
import classes from './Typography.module.scss'

export type TypographyProps = PropsWithChildren<{
  variant?: 'sm' | 'md' | 'lg' | 'xl' | 'xxl' | 'caption'
  isBold?: boolean
  isItalic?: boolean
  className?: string
}>

const Typography = ({ children, isBold = false, isItalic = false, variant = 'md', ...props }: TypographyProps) => {
  const className = clsx(
    classes.root,
    {
      [classes.bold]: isBold,
      [classes.italic]: isItalic,
      [classes.sm]: variant === 'sm',
      [classes.md]: variant === 'md',
      [classes.lg]: variant === 'lg',
      [classes.xl]: variant === 'xl',
      [classes.xxl]: variant === 'xxl',
      [classes.caption]: variant === 'caption',
    },
    props.className
  )

  return <div className={className}>{children}</div>
}

export default Typography
